<app-header></app-header>
<!-- Hero section -->
<div class="section-fullscreen position-relative" id="home">
    <!-- Background Video -->
    <div class="bg-video">
        <video autoplay [muted]="isMuted" loop>
            <source src="assets/videos/animated-video.mp4" type="video/mp4">
        </video>
    </div>
    <div class="bg-dark-06">
        <div class="container text-center z-index-1">
            <div class="position-middle">
                <h3 class="fw-thin display-6">We Make Smart, Good-Looking Things.</h3>
                <h1 class="display-1 fw-bold">Helifax</h1>
                <h4 class="fw-thin display-4">a Perfect Theme.</h4>
                <a class="button button-md button-rounded button-spring-red" href="#">Buy Template</a>
            </div>
            <!-- smoothscroll button -->
            <div class="position-bottom">
                <a class="button-circle button-circle-lg button-circle-white-2 icon-lg"
                    (click)="scrollToSection('about')">
                    <i class="bi bi-arrow-down"></i>
                </a>
            </div>
        </div><!-- end container -->
    </div>
</div>
<!-- end Hero section -->

<!-- About section -->
<div class="section" id="about">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <h3 class="color-primary">In real we trust.</h3>
                <h2 class="color-primary">Stay real. Always.</h2>
                <div class="mrt-30">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed suscipit, nisl nec interdum
                        ultrices, enim dolor commodo nulla, fringilla egestas.</p>
                </div>
            </div>
            <div class="col-sm-4 col-xs-12">
                <img class="img-responsive img-1" src="assets/images/about/about-img-3.jpg" alt="img-01">
            </div>
            <div class="col-sm-4 col-xs-12">
                <img class="img-responsive n-margin-8" src="assets/images/about/about-img-4.jpg" alt="img-02">
            </div>
        </div>
    </div>
</div>
<!-- end About section -->

<!-- Facts section -->
<div class="section-sm bg-image parallax" style="background-image: url('assets/images/backgrounds/main-bg-2.jpg')">
    <div class="bg-dark-06">
        <div class="container">
            <div class="row g-4 z-index-1">
                <!-- Counter box -->
                <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3 text-center">
                    <h1 class="fw-semi-bold color-white"><span class="counter">{{fact.displayedNumber | number:'1.0-0'}}</span></h1>
                    <h6 class="font-large fw-normal uppercase mt-2">{{fact.desc}}</h6>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Facts section -->

<!-- Team section -->
<div class="section-md" id="team">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
                <h3 class="color-primary">.Our Team</h3>
                <h2 class="color-primary">Together we can.</h2>
            </div>
        </div><!-- end row -->
        <div class="row team-wrapper border-radius gx-3 gy-4 mt-4">
            <!-- Team box -->
            <div *ngFor="let team of teams" class="col-12 col-sm-4 col-lg-4 team-box">
                <div class="team-member">
                    <figure class="team-memberpic">
                        <img src="assets/images/team/{{team.img}}" alt="image description">
                        <figcaption>
                            <ul class="member-socialicons">
                                <li *ngFor="let social of socialMedia">
                                    <a routerLink="/home-one"><i class="fa-brands" [ngClass]="social.icon"></i></a>
                                </li>
                            </ul>
                        </figcaption>
                    </figure>
                    <div class="team-memberinfo">
                        <h4>{{team.name}}</h4>
                        <h5>{{team.designation}}</h5>
                    </div>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Team section -->

<!-- Portfolio section -->
<div class="section" id="portfolio">
    <div class="container-fluid">
        <div class="row portfolio-grid g-4 hover-style-3 border-radius">
            <!-- Portfolio box 1 -->
            <div *ngFor="let work of works" class="col-12 col-md-6 col-lg-4 portfolio-item">
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img src="assets/images/portfolio/{{work.img}}" alt="gallery-img">
                    </div>
                    <a routerLink="/portfolio-one"></a>
                    <div class="portfolio-title">
                        <div class="portfolio-title-item">
                            <h5 class="uppercase letter-spacing-1 color-primary">{{work.name}}</h5>
                        </div>
                        <div class="portfolio-title-item">
                            <span>{{work.category}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end portfolio-masonry -->
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Pricing section -->
<div class="section-md bg-light-tan" id="pricing">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
                <h3 class="color-primary">.Our Pricing</h3>
                <h2 class="color-primary">Select One.</h2>
            </div>
        </div><!-- end row -->
        <div class="row gx-3 gy-4 mt-4">
            <!-- Price box -->
            <div *ngFor="let plan of pricingPlans" class="col-12 col-sm-4 col-lg-4 pricing pricing-row">
                <div class="pricing-item bg-color-white">
                    <i class="bi fts-50 color-primary" [ngClass]="plan.icon"></i>
                    <h3 class="pricing-title">{{ plan.title }}</h3>
                    <p class="pricing-sentence">{{ plan.description }}</p>
                    <div class="pricing-price">
                        <span class="pricing-currency">$</span>{{ plan.price }}
                        <span class="pricing-period">/ month</span>
                    </div>
                    <ul class="pricing-feature-list">
                        <li *ngFor="let feature of plan.features" class="pricing-feature">{{ feature }}</li>
                    </ul>
                    <a routerLink="/home-one" class="button button-lg theme-btn contact_now">Choose Plan</a>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Pricing section -->

<!-- Services section -->
<div class="section-md bg-dark" id="services">
    <div class="container">
        <div class="row g-4 g-lg-5 icon-xl">
            <!-- Service box -->
            <div *ngFor="let service of services" class="col-12 col-lg-4">
                <div class="circle-box-xl bg-color-spring-red mb-3">
                    <i class="bi color-white" [ngClass]="service.icon"></i>
                </div>
                <h4 class="fw-normal">{{service.title}}</h4>
                <p>{{service.desc}}</p>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Testimonials section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <div class="row=">
                <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStore">
                        <!-- Testimonial box -->
                        <div class="testimonial-box">
                            <img class="mb-3" src="assets/images/testimonials/{{slide.img}}" alt="testimonial-img">
                            <h5 class="fw-normal line-height-140 m-0">{{slide.name}}</h5>
                            <span class="font-small fw-normal">{{slide.designation}}</span>
                            <p class="mt-3">{{slide.desc}}</p>
                        </div>
                    </ng-template>
                </owl-carousel-o>
                <!-- end owl-carousel -->
            </div>
        </div>
    </div>
</div>
<!-- end Testimonials section -->

<!-- Blog section -->
<div class="section-lg" id="blogs">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
                <h3 class="color-primary">.Our Blog</h3>
                <h2 class="color-primary">Latest News.</h2>
            </div>
        </div>
        <div class="row mt-4">
            <div *ngFor="let blog of blogs" class="col-12 col-sm-4 col-lg-4">
                <article class="post">
                    <figure class="postimg">
                        <img src="assets/images/blogs/{{blog.img}}" alt="image description" class="img-responsive">
                    </figure>
                    <div class="description">
                        <div class="posttitle">
                            <h4 class="color-white">{{blog.title}}</h4>
                        </div>
                        <p>{{blog.desc}}</p>
                        <ul class="postmatadata">
                            <li><span class="datespan">{{blog.date}}</span></li>
                            <li><a routerLink="/home-one">{{blog.comments}}</a></li>
                        </ul>
                        <a class="btnreadmore" routerLink="/home-one">READ MORE</a>
                    </div>
                </article>
            </div>
        </div>
    </div>
</div>
<!-- end Blog section -->

<!-- Contact section -->
<div class="section-sm bg-light-spring-red pd-t-0 pd-b-0" id="contact">
    <div class="container-fluid pd-0">
        <div class="row g-0">
            <div class="col-md-12 col-lg-6 pd-t-100 pd-b-100 pd-l-50 pd-r-50 col-sm-12">
                <div class="row">
                    <div class="col-12">
                        <h3 class="color-primary">.Get in Touch</h3>
                        <h2 class="color-primary">Say Hello.</h2>
                    </div>
                </div>
                <form (submit)="sendEmail($event)" #contactForm="ngForm">
                    <div class="row gx-3 gy-0 mt-4">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Name</label>
                                <input type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_email">Email</label>
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="visually-hidden" for="message">Project Details</label>
                        <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                            class="md-textarea" id="message" rows="7" placeholder="Project Details"
                            [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                        <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                            Project details are required.
                        </div>
                    </div>
                    <button type="submit" name="submit" class="button button-lg button-rounded button-spring-red" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                </form>
                <!-- Submit result -->
            </div>
            <div class="col-md-12 col-lg-6 pd-0 col-sm-12">
                <div class="gmap">
                    <div id="map">
                        <img src="assets/images/map-img.jpg" alt="map-img">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end Contact section -->